import type { IconSvgObject } from './types';

const ListMinusIcon: IconSvgObject = [
  ["path", { d: "M2.99609 5H20.9961", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.99609 11.9951H20.9961", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.9961 19H2.99609", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20.9961 18.9902L14.9961 18.9902", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ListMinusIcon;
